import React from 'react';
import { AGENT_MODULES, BURGER_MODULES, CATEGORIES } from '../data/modules';

export default function Sidebar({ mode, lang, activeModule, onSelectModule, collapsed, onToggle, onSwitchMode }) {
  const isAgent = mode === 'agent';
  
  // Group agent modules by category
  const grouped = {};
  if (isAgent) {
    Object.entries(AGENT_MODULES).forEach(([key, mod]) => {
      if (!grouped[mod.cat]) grouped[mod.cat] = [];
      grouped[mod.cat].push({ key, ...mod });
    });
  }

  return (
    <div className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <button className="sidebar-toggle" onClick={onToggle}>
        {collapsed ? '▶' : '◀'}
      </button>

      {isAgent ? (
        // Agent mode: grouped by category
        Object.entries(CATEGORIES).map(([catKey, cat]) => (
          <div className="sidebar-section" key={catKey}>
            <div className={`sidebar-label ${catKey}`}>
              <span>{cat.icon}</span>
              <span>{cat[lang]}</span>
            </div>
            {(grouped[catKey] || []).map(mod => (
              <div
                key={mod.key}
                className={`sidebar-item${activeModule === mod.key ? ` active ${catKey}` : ''}`}
                onClick={() => onSelectModule(mod.key)}
              >
                <span className="sidebar-icon">{mod.icon}</span>
                <span className="sidebar-item-text">{mod[lang]}</span>
              </div>
            ))}
          </div>
        ))
      ) : (
        // Burger mode: flat list
        <div className="sidebar-section">
          <div className="sidebar-label" style={{ color: '#14b8a6' }}>
            <span>🏛️</span>
            <span>{lang === 'nl' ? 'Diensten' : 'Services'}</span>
          </div>
          {Object.entries(BURGER_MODULES).map(([key, mod]) => (
            <div
              key={key}
              className={`sidebar-item${activeModule === key ? ' active' : ''}`}
              onClick={() => onSelectModule(key)}
            >
              <span className="sidebar-icon">{mod.icon}</span>
              <span className="sidebar-item-text">{mod[lang]}</span>
            </div>
          ))}
        </div>
      )}

      {/* Switch mode button */}
      <div style={{ marginTop: 'auto', padding: '8px 0' }}>
        <button className="sidebar-mode-btn" onClick={onSwitchMode}>
          <span>{isAgent ? '🏛️' : '👮'}</span>
          <span className="sidebar-item-text">
            {isAgent
              ? (lang === 'nl' ? 'Naar Burger Modus' : 'Switch to Citizen Mode')
              : (lang === 'nl' ? 'Naar Agent Modus' : 'Switch to Agent Mode')}
          </span>
        </button>
      </div>
    </div>
  );
}
